"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Stack_1 = require("./Stack");
var HSplit_1 = require("./HSplit");
var VSplit_1 = require("./VSplit");
var Grid_1 = require("./Grid");
var StackViewFactory = function (comp) {
    return React.createElement(Stack_1.Stack, { stack: comp });
};
var HSplitViewFactory = function (comp) {
    return React.createElement(HSplit_1.HSplit, { hsplit: comp });
};
var VSplitViewFactory = function (comp) {
    return React.createElement(VSplit_1.VSplit, { vsplit: comp });
};
var GridViewFactory = function (comp) {
    return React.createElement(Grid_1.Grid, { grid: comp });
};
var ViewFactoryMap = {
    stack: StackViewFactory,
    hsplit: HSplitViewFactory,
    vsplit: VSplitViewFactory,
    grid: GridViewFactory
};
var ViewFactory = function (comp) {
    if (comp) {
        var f = ViewFactoryMap[comp.type];
        if (f) {
            return f(comp);
        }
    }
    return null;
};
exports.default = ViewFactory;
exports.ViewFactory = ViewFactory;
